import { render, staticRenderFns } from "./D202.vue?vue&type=template&id=a4ab55bc&scoped=true"
import script from "./D202.vue?vue&type=script&lang=js"
export * from "./D202.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=a4ab55bc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ab55bc",
  null
  
)

export default component.exports